import React from 'react';
import { Spinner } from 'react-bootstrap';
import { SSpinnerOverlay, SSpinnerloading } from './styles';

const LoadingSpinner = ({ isLoading }) => {
  
  if (!isLoading) {
    return null; // Não renderiza o spinner se isLoading for falso
  }

  return (
    <SSpinnerOverlay>
      {/* <SSpinnerloading> */}
        <Spinner animation="grow" variant="light" />
      {/* </SSpinnerloading> */}
    </SSpinnerOverlay>
  );
};

export default LoadingSpinner;